export default __webpack_public_path__ + "static/media/icon-upload-now.c23046a2.svg";